"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getPatient_1 = tslib_1.__importDefault(require("../getPatient"));
const getUserByParam_1 = tslib_1.__importDefault(require("./getUserByParam"));
var types;
(function (types) {
    types["ws"] = "ws";
    types["uid"] = "uid";
    types["dni"] = "dni";
    types["email"] = "email";
})(types || (types = {}));
/**
 * Sólo se puede usar esta función si tiene suficientes permisos
 * sobre la DB, intentar usarla sin eso devolverá un error por falta de permisos
 *
 * @param {IPatientOptions} parameter objeto con el parametro a chequear
 * @example
 * getUserByProp({ws : 4462596})
 * getUserByProp(uid: 'fasdasd')
 * getUserByProp(dni: '41793759')
 * getUserByProp(email: 'f@gmail.com')
 * @example
 * // Si intentas pasar más de un parametro el compilador de TS arrojará el siguiente error
 * getUserByProp(email: 'f@gmail.com', uid: 'fasdf') // Argument of type '{ email: string; uid: string; }' is not assignable to parameter of type 'IPatientOptions'.
 * @returns {Promise<IPatient | IPatient[]>} Devuelve uno o varios usuarios
 */
async function getUserByProp(firestore, parameter) {
    const keys = Object.keys(parameter);
    // Aunque confie en Typescript, chequeo en tiempo de runtime si se paso una sola key
    if (keys.length > 1) {
        throw new Error("Pasaste más de una opción, tu objeto debería ser algo así {email: a@gmail.com} y nunca algo así {email: a@gmail.com , ws: 4462532}, chequeá estar pasando un sólo parametro, Typescript de todas formas no te debería dejar pasar más de uno.");
    }
    const key = Object.keys(parameter)[0];
    // Chequeo en tiempo de runtime si esa key es válida
    if (!Object.keys(types).includes(key)) {
        throw new Error(`Pasaste una prop que todavía no tenemos, la prop debería ser una de estás ${JSON.stringify(Object.keys(types))}`);
    }
    if (key === "uid") {
        return (0, getPatient_1.default)(firestore, parameter[key]);
    }
    return (0, getUserByParam_1.default)(firestore, key, parameter[key]);
}
exports.default = getUserByProp;
